import Reflux from 'reflux';

const KlarnaActions = Reflux.createActions([
  'getAddressesBySsn',
  'getAddressesBySsnComplete',
  'change'
]);

export default KlarnaActions;



// WEBPACK FOOTER //
// ./src/js/actions/Klarna.js